module.exports = __webpack_public_path__ + "1c27a439ac924a60bc9ca6b173670717.png";